var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProfile = function SvgProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 12.4,
    r: 4.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 1.6C8 1.6 1.6 8 1.6 16S8 30.4 16 30.4 30.4 24 30.4 16 24 1.6 16 1.6m7.4 24-1-4.8c-.4-1.6-1.6-2.6-3-3h-.6c-.8.4-1.8.6-2.6.6-1 0-1.8-.2-2.6-.6-.2 0-.4-.2-.6 0-1.4.4-2.6 1.6-3 3l-1 4.8c-3.2-2.2-5-5.8-5-9.6C4 9.4 9.4 4 16 4s12 5.4 12 12c0 4-1.8 7.4-4.6 9.6"
  })));
};
export default SvgProfile;